import type { Page } from '../../types';
import { REPORTING_PERIOD } from './shared_variables';
import { getKeys as getExternalCompetitionsKeys } from '../../../components/form/InputExternalCompetitions';

const breaches: Page[] = [
  {
    pageType: 'question',
    title: 'Breaches',
    name: 'fair-and-open-breach-page',
    hidePageTitle: true,
    description: '',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      // {
      //     questionType: 'inset',
      //     title: '',
      //     insetContent: 'In quesion 9, you reported X people recruited through fair and open competition<br><br>'+
      //     'The total of this question should equal X<br><br>'+
      //     'In question 10, you provided a breakdown of the grades you recruited. The grade totals will need to match these.',
      //     name: 'external-recruit-ethnicity-inset',
      //     detailsContent: 'Key contact 2 email address',
      //     rules: {
      //         required: false,
      //     },
      // },
      {
        questionType: 'breachesInput',
        title: `Number of breaches to the Recruitment Principles between ${REPORTING_PERIOD}`,
        name: 'breaches-grade-column',
        hint: 'You should include all breaches which have been confirmed by the Commission if they fall into the quarterly survey period you are reporting for. If you are unsure, please contact compliance@csc.gov.uk and we will confirm recorded breaches. Unconfirmed breaches should not be recorded in your quarterly survey return. You should report breaches to the Commission as they happen and seek confirmation',
        detailsContent: `<p>If the grade does not align directly, you can use the equivalent.</p>
                         <p>The data provided in this section should include numbers from any arm's length bodies, if these numbers relate to the appointment of civil servants or the advertisement of civil service vacancies. </p>`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInputSmall',
        title: 'Total',
        name: 'breaches-total',
        rules: {
          required: true,
        },
        autoFill: {
          keys: getExternalCompetitionsKeys(),
          field: 'breaches-grade-column',
        },
      },
      {
        questionType: 'textarea',
        title:
          'Please provide a brief explanation of each breach with reference to the cause of the breach, the date that the breach was identified, the date that the breach was confirmed with the CSC.',
        hint: 'Please provide any additional information that you think would be useful for our understanding. Do not include any personal details, including names, in this response.',
        name: 'fair-and-open-breach-explanation',
        rules: {
          required: true,
        },
      },
    ],
  },
];
export default breaches;
